jQuery(document).ready(function ($) {

});

